import { Information } from '@carbon/icons-react'
import { FieldContext } from 'lib/formContext'
import { type ReactNode, use } from 'react'
import { twMerge } from 'tailwind-merge'
import { Tooltip } from '../Tooltip'

interface Props {
  htmlFor: string
  children: ReactNode
  tooltip?: ReactNode
  className?: string
}

export function Label({ htmlFor, children, tooltip, className }: Props) {
  const context = use(FieldContext)

  return (
    <label
      id={`${htmlFor}-label`}
      htmlFor={htmlFor}
      className={twMerge(
        'text-text-secondary flex w-full grow-0 gap-2 label-01',
        context?.disabled && 'text-gray-disabled',
        className,
      )}
    >
      <span className="break-all">{children}</span>
      {tooltip && (
        <Tooltip
          side="right"
          content={tooltip}
          icon={<Information className="h-4 w-4" />}
          iconAriaLabel="Informationen"
        />
      )}
    </label>
  )
}
